var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#F8991C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    fill: "#F8991C"
  }, ".cls-1{fill:#F8991C;}.cls-2{fill:#F8991C;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "outline color",
    id: "outline_color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.26,60A3.26,3.26,0,0,1,22,56.74V30a1,1,0,0,1,1-1H34a1,1,0,0,1,1,1v3H54a1,1,0,0,1,1,1v5a1,1,0,1,1-2,0V35H34a1,1,0,0,1-1-1V31H24V56.74A1.26,1.26,0,0,0,25.26,58a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,60H25.26a1,1,0,0,1,0-2,1.25,1.25,0,0,0,1.25-1.26V39a1,1,0,0,1,1-1H59a1,1,0,0,1,1,1V59A1,1,0,0,1,59,60ZM28.26,58H58V40H28.51V56.74A3.29,3.29,0,0,1,28.26,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,54a1,1,0,0,1-.69-.27,5.19,5.19,0,0,1-1.11-1.57L4.56,23.83a5,5,0,0,1,2.52-6.6l20.17-9A1,1,0,0,1,28.07,10l-20.17,9a3,3,0,0,0-1.52,4L19,51.32a3,3,0,0,0,.67.94A1,1,0,0,1,19,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.13,31a.75.75,0,0,1-.26,0,1,1,0,0,1-.7-1.22L57.9,16.11a3,3,0,0,0-.29-2.28,2.94,2.94,0,0,0-1.82-1.4L32.65,6.08A3,3,0,0,0,29,8.2L24,26.26a1,1,0,0,1-1.93-.52L27,7.67a5,5,0,0,1,6.14-3.51L56.31,10.5a4.9,4.9,0,0,1,3,2.33,5,5,0,0,1,.49,3.8L56.09,30.26A1,1,0,0,1,55.13,31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.af5b1c87e1a3b85737c6156af529ceaf.svg";
export { ForwardRef as ReactComponent };